import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  0% { opacity: 0; transform: translateY(8px); }
  100% { opacity: 1; transform: translateY(0); }
`;

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

export const Modal = styled.div`
  width: 100%;
  max-width: 420px;
  background: ${({ theme }) => theme.baseCardBackground ?? '#ffffff'};
  border-radius: 14px;
  padding: 16px 16px 20px;
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.35);
  animation: ${fadeIn} 0.25s ease-out;
  box-sizing: border-box;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 12px;

  h3 {
    margin: 0;
    font-size: 1rem;
    color: ${({ theme }) => theme.baseTextPrimary};
  }

  button {
    border: none;
    background: transparent;
    cursor: pointer;
    font-size: 1rem;
    line-height: 1;
    color: ${({ theme }) => theme.baseTextSecondary};
  }
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const QRWrapper = styled.div`
  display: flex;
  justify-content: center;

  img {
    width: 180px;
    height: 180px;
    object-fit: contain;
    border-radius: 12px;
    background: #ffffff;
  }
`;

export const Instruction = styled.p`
  margin: 0;
  font-size: 0.85rem;
  color: ${({ theme }) => theme.baseTextSecondary};
  text-align: center;
`;

export const CodeBox = styled.div`
  textarea {
    width: 100%;
    min-height: 80px;
    border-radius: 8px;
    border: 1px solid ${({ theme }) => theme.baseBorder};
    padding: 8px;
    font-size: 0.8rem;
    resize: none;
    box-sizing: border-box;
    color: ${({ theme }) => theme.baseTextPrimary};
    background: ${({ theme }) => theme.baseInputBackground ?? '#f9fafb'};
  }
`;

export const CopyButton = styled.button`
  width: 100%;
  margin-top: 4px;
  border-radius: 8px;
  border: none;
  padding: 10px 12px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  background: ${({ theme }) => theme.colorPrimary ?? '#10b981'};
  color: #fff;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.9;
  }
`;
